import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4862245c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  ref: "imageWrapper"
}
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "floorNum" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = {
  key: 1,
  class: "ImgShow"
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("operater")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.datastatistics}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("datastatistics")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.cardatastatistics}?vin=${_ctx.detail?.vin}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("singlecardatastatistics")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("taskdetails")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, "vin:" + _toDisplayString(_ctx.detail?.vin), 1),
          _createVNode(_component_a_button, {
            style: {"background-color":"#4f6bff"},
            type: "primary",
            onClick: _ctx.clickGeneratePicture
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("export")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_a_row, { class: "group" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("taskname")) + "：" + _toDisplayString(_ctx.detail?.task_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("tasktype")) + "：" + _toDisplayString(_ctx.taskType === "2" ? _ctx.t("multifloortasks") : _ctx.t("combinedtasks")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("mapname")) + "：" + _toDisplayString(_ctx.detail?.map_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { class: "group" }, {
          default: _withCtx(() => [
            (_ctx.detail?.vehicle_model !== 'Mix1')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("cleaningmode")) + "：" + _toDisplayString(_ctx.detail?.clean_mode), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("cleaningfrequency")) + "：" + _toDisplayString(_ctx.detail?.cycle_index), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("scheduledtasks")) + "：" + _toDisplayString(_ctx.detail?.is_timing === "0" ? _ctx.t("deny") : _ctx.t("yes")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { class: "group" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("cleaningtime")) + "：" + _toDisplayString(_ctx.timeConversion(_ctx.detail?.total_time)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("cleaningefficiencyh")) + "：" + _toDisplayString(_ctx.detail?.clean_rate) + " ㎡/h", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("taskcompletionrate")) + "：" + _toDisplayString(Math.floor(Number(_ctx.detail?.task_completion))) + " %", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { class: "group" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("waterconsumption")) + "：" + _toDisplayString(_ctx.detail?.use_water) + " L", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("electricityconsumption")) + "：" + _toDisplayString(_ctx.detail?.power_consumption) + " kW·h", 1)
              ]),
              _: 1
            }),
            (_ctx.detail?.vehicle_model !== 'Mix1')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("supplyfrequency")) + "：" + _toDisplayString(_ctx.detail?.supply_times), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { class: "group" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("operator")) + "：" + _toDisplayString(_ctx.detail?.cleaner), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("starttime")) + "：" + _toDisplayString(_ctx.detail?.start_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("endtime")) + "：" + _toDisplayString(_ctx.detail?.end_time), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.detail?.floor_task_report === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.floor_task_report_extension, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item?.id,
              class: "ImgShow"
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item?.floor_name), 1),
              _createElementVNode("img", {
                src: item?.task_finish_clean_pic,
                alt: "",
                crossorigin: "anonymous"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(_ctx.t("mapname")) + "：" + _toDisplayString(item?.map_name), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("combinationtaskname")) + "：" + _toDisplayString(item?.task_name), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("cleaningfrequency")) + "：" + _toDisplayString(item?.cycle_index), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("plannedcleaningaream2")) + "：" + _toDisplayString(item?.plan_clean_area) + "㎡", 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("actualcleaningaream2")) + "：" + _toDisplayString(item?.actual_clean_area) + "㎡ ", 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("uncleanedaream2")) + "：" + _toDisplayString(item?.uncleaned_area) + "㎡", 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.t("taskcompletionrate")) + "：" + _toDisplayString(item?.task_completion.substring(
                0,
                item?.task_completion.indexOf(".") + 3
              )) + " % ", 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.detail?.floor_task_report === '0' || _ctx.detail?.vehicle_model === 'Mix1'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.detail?.task_finish_clean_pic,
            alt: "",
            crossorigin: "anonymous"
          }, null, 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}